
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb3e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb3e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1RSkv", function(module, exports) {

$parcel$export(module.exports, "isMessageUpdateRect", function () { return $fea37e04733dede6$export$9bfb09ec575e020d; });
$parcel$export(module.exports, "isMessageUpdateContent", function () { return $fea37e04733dede6$export$720de8edf8d57228; });
$parcel$export(module.exports, "isMessageUpdateRects", function () { return $fea37e04733dede6$export$8f98d2096cf4ed84; });
$parcel$export(module.exports, "isMessageSetMobile", function () { return $fea37e04733dede6$export$fd18b7ddd48b3180; });
$parcel$export(module.exports, "isMessageSetField", function () { return $fea37e04733dede6$export$8f812cc4991bbcbd; });
$parcel$export(module.exports, "isMessageSetFrameId", function () { return $fea37e04733dede6$export$533d955307da5d01; });
const $fea37e04733dede6$export$fb56ad75dd311c12 = (field)=>{
    return typeof field === "object" && field !== null && "id" in field && typeof field.id === "string" && "name" in field && typeof field.name === "string" && "type" in field && typeof field.type === "string" && "defaultValue" in field && typeof field.defaultValue === "string" && (!("exampleValues" in field) || "exampleValues" in field && typeof field.exampleValues === "undefined" || "exampleValues" in field && Array.isArray(field.exampleValues));
};
const $fea37e04733dede6$export$9bfb09ec575e020d = (message)=>{
    return typeof message === "object" && message !== null && "type" in message && message.type === "update-rect" && "id" in message && typeof message.id === "string" && "frameId" in message && typeof message.frameId === "string";
};
const $fea37e04733dede6$export$720de8edf8d57228 = (message)=>{
    return typeof message === "object" && message !== null && "type" in message && message.type === "update-content";
};
const $fea37e04733dede6$export$8f98d2096cf4ed84 = (message)=>{
    return typeof message === "object" && message !== null && "type" in message && message.type === "update-rects";
};
const $fea37e04733dede6$export$fd18b7ddd48b3180 = (message)=>{
    return typeof message === "object" && message !== null && "type" in message && message.type === "set-mobile" && "mobile" in message && typeof message.mobile === "boolean";
};
const $fea37e04733dede6$export$8f812cc4991bbcbd = (message)=>{
    return typeof message === "object" && message !== null && "type" in message && message.type === "set-editable" && "editable" in message && typeof message.editable === "boolean";
};
const $fea37e04733dede6$export$533d955307da5d01 = (message)=>{
    return typeof message === "object" && message !== null && "type" in message && message.type === "set-frame-id" && "frameId" in message && typeof message.frameId === "string";
};

});


var $1RSkv = parcelRequire("1RSkv");
let $de5a1b270ae81c77$var$frameId = null;
const $de5a1b270ae81c77$var$areaElements = Array.from(document.querySelectorAll("[data-area]")).map((el)=>{
    const id = el.getAttribute("data-area");
    const updateRect = ()=>{
        const rect = el.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0 || $de5a1b270ae81c77$var$frameId === null) return;
        const message = {
            type: "update-rect",
            id: id,
            rect: rect,
            frameId: $de5a1b270ae81c77$var$frameId
        };
        parent.postMessage(message);
    };
    updateRect();
    const observer = new ResizeObserver((entries)=>{
        for (const entry of entries)if (entry.contentRect) updateRect();
    });
    observer.observe(el);
    return {
        updateRect: updateRect
    };
});
const $de5a1b270ae81c77$var$fieldElements = Array.from(document.querySelectorAll("[data-field]")).map((el)=>{
    const id = el.getAttribute("data-field");
    return {
        id: id,
        el: el
    };
});
const $de5a1b270ae81c77$var$updateRects = ()=>{
    $de5a1b270ae81c77$var$areaElements.forEach(({ updateRect: updateRect })=>updateRect());
};
/**
 * Listen for messages to update content
 */ window.addEventListener("message", (event)=>{
    const message = event.data;
    if ((0, $1RSkv.isMessageSetFrameId)(message)) $de5a1b270ae81c77$var$frameId = message.frameId;
    if ((0, $1RSkv.isMessageUpdateContent)(message)) {
        let shouldUpdateRects = false;
        $de5a1b270ae81c77$var$fieldElements.forEach(({ id: id, el: el })=>{
            const value = message.fieldValues[id];
            if (value !== undefined && value !== "") {
                el.classList.add("has-value");
                if (el instanceof HTMLImageElement) el.src = value;
                else {
                    el.innerText = value;
                    shouldUpdateRects = true;
                }
            }
        });
        if (shouldUpdateRects) window.setTimeout($de5a1b270ae81c77$var$updateRects, 1);
    }
    if ((0, $1RSkv.isMessageSetMobile)(message)) {
        document.documentElement.classList.toggle("is-mobile", message.mobile);
        $de5a1b270ae81c77$var$updateRects();
    }
    if ((0, $1RSkv.isMessageSetField)(message)) {
        document.documentElement.classList.toggle("is-editable", message.editable);
        $de5a1b270ae81c77$var$updateRects();
    }
    if ((0, $1RSkv.isMessageUpdateRects)(message)) $de5a1b270ae81c77$var$updateRects();
});
window.addEventListener("load", $de5a1b270ae81c77$var$updateRects);
window.addEventListener("DOMContentLoaded", $de5a1b270ae81c77$var$updateRects);


//# sourceMappingURL=card-minnesgava.02802bde.js.map
